import styled from "styled-components";

import { Tag } from "antd";
import { theme } from "../../styles/theme";

export const CustomTag = styled(Tag)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 357px;
  min-width: ${({ width }) => width || "92px"};
  height: ${({ height }) => height || "39px"};
  color: ${({ color }) => color || theme.colors.white};
  background-color: ${({ background }) => background || theme.colors.purple500};
  opacity: ${({ opacity }) => opacity || "1"};
  font-color: ${({ fc }) => fc || theme.colors.white};
  font-size: ${({ size }) => size || theme.fonts.size.sm};
  font-weight: ${({ weight }) => weight || theme.fonts.weight.regular};
  border: ${({ border }) => border || "1px solid"};
  border-radius: ${({ br }) => br || "20px"};
  border-color: ${({ bc }) => bc || "transparent"};
  text-align: ${({ text }) => text || "center"};
  margin: ${({ m }) => m || "5px"};
  padding: ${({ m }) => m || "12px"};
  box-shadow: ${({ bs }) => bs || ""};
  font-family: ${({ font }) => font || theme.fonts.family};

  .ant-tag-close-icon {
    color: ${theme.colors.white}; 
  }

  .ant-tag {
    &-close-icon {
      display: flex;
    }
`;
